export const EVENT_EFT_ENTER_GAME = "EVENT_EFT_ENTER_GAME";
export const EVENT_EFT_EXIT_GAME = "EVENT_EFT_EXIT_GAME";
